export enum CollapseItemsEnum {
  takeInCharge = "takeInCharge",
  updateActivity = "updateActivity",
  updateResponsible = "updateResponsible",
  closeWorkorder = "closeWorkorder",
  changeStatus = "changeStatus",
  addPhoto = "addPhoto",
  returnDDS = "returnDDS",
  addInternalComment = "addInternalComment",
  cancelTakeInCharge = "cancelTakeInCharge",
}

export class CollapseItemValidation {
  private status = false;
  private reason = false;
  private addPhoto = false;
  private internalComment = false;
  private allowableResponsiblesList = false;
  private allowableActivityList = false;

  constructor(
    status: boolean,
    reason: boolean,
    addPhoto: boolean,
    internalComment: boolean,
    allowableResponsiblesList: boolean,
    allowableActivityList: boolean,
  ) {
    this.status = status;
    this.reason = reason;
    this.addPhoto = addPhoto;
    this.internalComment = internalComment;
    (this.allowableResponsiblesList = allowableResponsiblesList),
      (this.allowableActivityList = allowableActivityList);
  }

  public getValidationByName(name: string): boolean {
    return this[name];
  }
}

export class ItemPropertiesVisibility {
  private hasAssignStatus = true;
  private hasResponseToClient = true;
  private hasAddPhoto = true;
  private hasInternalComment = true;
  private hasAssignAllowableUser = true;
  private hasAssignAllowableActivity = true;

  constructor(
    hasAssignStatus: boolean,
    hasResponseToClient: boolean,
    hasAddPhoto: boolean,
    hasInternalComment: boolean,
    hasAssignAllowableUser: boolean,
    hasAssignAllowableActivity: boolean,
  ) {
    this.hasAssignStatus = hasAssignStatus;
    this.hasResponseToClient = hasResponseToClient;
    this.hasAddPhoto = hasAddPhoto;
    this.hasInternalComment = hasInternalComment;
    this.hasAssignAllowableUser = hasAssignAllowableUser;
    this.hasAssignAllowableActivity = hasAssignAllowableActivity;
  }

  public getHasAssignStatus(): boolean {
    return this.hasAssignStatus;
  }

  public getHasResponseToClient(): boolean {
    return this.hasResponseToClient;
  }

  public getHasAddPhoto(): boolean {
    return this.hasAddPhoto;
  }

  public getHasInternalComment(): boolean {
    return this.hasInternalComment;
  }

  public getHasAssignAllowableUser(): boolean {
    return this.hasAssignAllowableUser;
  }

  public getHasAssignAllowableActivity(): boolean {
    return this.hasAssignAllowableActivity;
  }
}

export class CollapseItem {
  private collapsed = true;
  private btnDisabled = false;
  private btnAlwaysDisabled = false;
  private btnAlwaysDisabledMsg = "";
  private btnVisible = true;
  private sessionVisible = true;
  private name: CollapseItemsEnum;
  private visibilities: ItemPropertiesVisibility;
  private validations: CollapseItemValidation;

  constructor(
    name: CollapseItemsEnum,
    visibilities: ItemPropertiesVisibility,
    validations: CollapseItemValidation,
    btnAlwaysDisabled: boolean,
    btnAlwaysDisabledMsg?: string,
  ) {
    this.name = name;
    this.visibilities = visibilities;
    this.btnAlwaysDisabled = btnAlwaysDisabled;
    this.validations = validations;
    this.btnAlwaysDisabledMsg = btnAlwaysDisabledMsg;
  }

  public getName(): CollapseItemsEnum {
    return this.name;
  }

  public getCollapsed(): boolean {
    return this.collapsed;
  }

  public setCollapsed(value: boolean): void {
    this.collapsed = value;
  }

  public getBtnDisabled(): boolean {
    return this.btnAlwaysDisabled || this.btnDisabled;
  }

  public setBtnDisabled(value: boolean): void {
    this.btnDisabled = value;
  }

  public getBtnVisible(): boolean {
    return this.btnVisible;
  }

  public setBtnVisible(value: boolean): void {
    this.btnVisible = value;
  }

  public getSessionVisible(): boolean {
    return this.sessionVisible;
  }

  public setSessionVisible(value: boolean): void {
    this.sessionVisible = value;
  }

  public getWarningMessage(): string {
    return this.btnAlwaysDisabledMsg;
  }

  public needAssignStatus(): boolean {
    return this.visibilities.getHasAssignStatus();
  }

  public needResponseToClient(): boolean {
    return this.visibilities.getHasResponseToClient();
  }

  public needAddPhoto(): boolean {
    return this.visibilities.getHasAddPhoto();
  }

  public needInternalComment(): boolean {
    return this.visibilities.getHasInternalComment();
  }

  public needAssignAllowableUser(): boolean {
    return this.visibilities.getHasAssignAllowableUser();
  }

  public needAssignAllowableActivity(): boolean {
    return this.visibilities.getHasAssignAllowableActivity();
  }

  public getOnlyCompletedStatus(): boolean {
    return false;
  }

  public getValidations(): CollapseItemValidation {
    return this.validations;
  }
}

export class CloseWorkorderCollapseItem extends CollapseItem {
  constructor(
    name: CollapseItemsEnum,
    visibilities: ItemPropertiesVisibility,
    validations: CollapseItemValidation,
    btnAlwaysDisabled: boolean,
    btnAlwaysDisabledMsg?: string,
  ) {
    super(
      name,
      visibilities,
      validations,
      btnAlwaysDisabled,
      btnAlwaysDisabledMsg,
    );
  }

  public getOnlyCompletedStatus(): boolean {
    return true;
  }
}
